import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
import UnderConstruction from "../container/Blank/UnderConstruction";

// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Transportation = () => {
  const show = true;
  if (show) {
    return (
      <React.Fragment>
        <SEO title="Transportation | ICSI 2025" />
        <Header />
        <Breadcrumb
          image="images/banner/banner.jpg"
          title="Transportation"
          content="For Participants"
          contentTwo="Transportation"
          linkage="/"

        />

        <EmptyTwo>
          <div className="entry-content">


            <h2>Transportation facilities in Tokyo</h2>
            <br></br>



            <h3>Haneda Airport</h3>
            <br />

            <p>
              <div className="title-center"
              >
                <img
                  src="./images/transportation/haneda.jpg"
                  width={800}
                />

              </div>
            </p>
            <br />
            <p>
              Haneda Airport (羽田空港, Haneda Kūkō) (IATA: HND, ICAO: RJTT), sometimes referred to as Tokyo-Haneda, is one of two international airports serving the Greater Tokyo Area, the other being Narita International Airport (NRT). It serves as the primary domestic base of Japan&apos;s two largest airlines, Japan Airlines (Terminal 1) and All Nippon Airways (Terminal 2), as well as RegionalPlus Wings Corp. (Air Do and Solaseed Air), Skymark Airlines, and StarFlyer. It is located in Ōta, Tokyo, 15 kilometers (9.3 mi) south of Tokyo Station. The facility covers 1,522 hectares (3,761 acres) of land.
              <br></br>
              <br></br>
              Haneda previously carried the IATA airport code TYO, which is now used by airline reservation systems within the Greater Tokyo Area, and was the primary international airport serving Tokyo until 1978. From 1978 to 2010, Haneda handled almost all domestic flights to and from Tokyo as well as &quot;scheduled charter&quot; flights to a small number of major cities in East and Southeast Asia, while Narita handled the vast majority of international flights from further locations. In 2010, a dedicated international terminal, currently Terminal 3, was opened at Haneda in conjunction with the completion of a fourth runway, allowing long-haul flights to operate during night-time. Haneda opened up to long-haul service during the daytime in March 2014, with carriers offering nonstop service to 25 cities in 17 countries. Since the resuming of international flights, airlines in Japan strategize Haneda as &quot;Hub of Japan&quot;: providing connections between intercontinental flights with Japanese domestic flights, while envisioning Narita as the &quot;Hub of Asia&quot; between intercontinental destinations with Asian destinations.
            </p>

            <p>
              For more information, please visit{" "}
              <a href="https://tokyo-haneda.com/en/">https://tokyo-haneda.com/en/</a>
            </p>

            <p>&nbsp;</p>
            <h3>Narita International Airport</h3>
            <br />
            <div className="title-center">
              <img
                src="./images/transportation/narita.jpg"
                width={800}
              />

            </div>
            <p>
              <br />
              Narita International Airport (成田国際空港, Narita Kokusai Kūkō) (IATA: NRT, ICAO: RJAA), also known as Tokyo-Narita International Airport or simply Narita Airport, formerly and originally known as New Tokyo International Airport (新東京国際空港, Shin Tōkyō Kokusai Kūkō), is one of two international airports serving the Greater Tokyo Area, the other one being Haneda Airport (HND). It is about 60 km (37 mi) east of central Tokyo in Narita, Chiba. The facility, since July 2019, covers 1,137 hectares (2,810 acres) of land and construction to expand to nearly 2,300 ha (5,700 acres) is under way.
              <br></br>
              <br></br>

              Narita is the busiest airport in Japan by international passenger and international cargo traffic. In 2018, Narita had 33.4 million international passengers and 2.2 million tonnes of international cargo. In 2018, Narita was also the second-busiest airport in Japan in terms of aircraft movements (after Haneda Airport in Tokyo) and the tenth-busiest air freight hub in the world. Its 4,000-meter (13,123 ft) main runway shares the record for longest runway in Japan with the second runway at Kansai International Airport in Osaka. Narita serves as the main international hub of Japan Airlines, All Nippon Airways and Nippon Cargo Airlines, and as an operating base for low-cost carriers Air Japan, Jetstar Japan, Peach Aviation, Spring Airlines Japan, and Zipair Tokyo.
            </p>

            {/* <p>&nbsp;</p>
            <h3>Shenzhen Railway Station</h3>
            <br />
            <div className="title-center">
              <img
                src="./images/transportation/shenzhen.jpg"
                width={600}
              />

            </div>
            <p>
              <br />
              Shenzhen Railway Station, located in Luohu District, Shenzhen City, Guangdong Province, China, is a first-class station under the jurisdiction of China Railway Guangzhou Bureau Group Co., Ltd. It is also one of the departure and arrival stations of international trains.
            </p> */}


            {/* <h2>Transportation to the venue</h2>
            <br></br>

            <h5>
              From Xining Caojiabao Airport:

            </h5>

            <b>Bus: </b>Take the combined route of Airport Bus Line 1/2 and then walk to the venue. (approximately 80 minutes).
            <br></br>
            <div className="title-center">

              <img
                src="./images/transportation/way1.png"
                alt="way1"
                width="55%"
              />

            </div>
            <br></br>
            <b>
              Taxi/Ride-Hailing Service:    </b>
            Take a taxi or ride-hailing service from the designated pick-up point at the airport to Qinghai Hotel (approximately 45 minutes).
            <br></br>
            <br></br>

            <h5>
              From Xining Railway Station:
            </h5>

            <b>Bus: </b> <ol>
              <li>Board the bus at Xining Railway Station (Platform ②).</li>
              <li>Take Bus No. 47 for 11 stops.</li>
              <li>Get off at Xinhua Alley Entrance (Xinhua Xiangkou) Station.</li>
            </ol>
            <br></br>
            <br></br>
            <div className="title-center">

              <img
                src="./images/transportation/way2.png"
                alt="way2"
                width="55%"
              />

            </div>
            <br></br>
            <b>Taxi/Ride-Hailing Service:</b> Take a taxi or ride-hailing service from the designated pick-up point at the railway station to Qinghai Hotel (approximately 15 minutes).

            <br></br>
            <br></br> */}




          </div>
        </EmptyTwo>
        {/* <AboutFive />
				  <TestimonialContainer classOption="bg-primary-blue" />
				  <CallToActionTwo /> */}
        <Footer />
        <ScrollToTop />
      </React.Fragment>
    );
  }
  else {
    return (
      <React.Fragment>
        <SEO title="Transportation | ICSI 2023" />
        <Header />
        <Breadcrumb
          image="images/banner/banner.jpg"
          title="Transportation"
          content="For Participants"
          contentTwo="Transportation"
          linkage="/"

        />

        <EmptyTwo>
          <UnderConstruction />
        </EmptyTwo>
        <Footer />
        <ScrollToTop />
      </React.Fragment>
    );
  }
};

export default Transportation;
